var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTimeShare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.4 21.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-linecap: round;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #8b8c9e;\n        stroke-linejoin: round;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.8,21.41v-4.8l3.93-3.57,3.93,3.57v4.8h-7.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M.5,8.87V4.07L4.43,.5l3.93,3.57v4.8H.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.65,18.29c-1.17-.09-2.31-.55-3.25-1.39-1.17-1.05-1.8-2.48-1.86-3.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "1.22 12.86 2.57 11.66 3.86 12.93"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.46,5.03c1.17,.09,2.31,.55,3.25,1.39,1.17,1.05,1.8,2.48,1.86,3.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "17.9 10.45 16.54 11.66 15.25 10.39"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeShare);
export default __webpack_public_path__ + "static/media/TimeShare.a283b097.svg";
export { ForwardRef as ReactComponent };